import React, { useState, useEffect } from 'react'
import { Panel, Form, Row, Message } from 'rsuite'
import { useHistory, useParams } from 'react-router-dom'
import { useForm, Controller } from 'react-hook-form'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import ProposalFilterSummaryForm from '../../components/forms/proposalFilterSummaryForm/ProposalFilterSummaryForm'
import SingleDropdownForm from '../../components/forms/singleDropdownForm/SingleDropdownForm'
import SingleRadioForm from '../../components/forms/singleRadioForm/SingleRadioForm'
import ProposalReviseForm from '../../components/forms/proposalReviseForm/ProposalReviseForm'
import { startLoading, doneLoading } from '../../utils/loading'
import { saveProposalFilter6, saveProposalFilterCoi } from '../../redux/actions/proposalFilter6'
import { saveProposalFilterOther } from '../../redux/actions/proposalFilterOther'
import pathname from '../../constants/pathname'
import ConfirmWidget from '../confirm/ConfirmWidget'
import { ProposalFilterType } from '../../constants/proposalFilter'
import COIValidateWidget from '../coi/COIValidateWidget'
import notification from '../../utils/notification'

export default function ProposalFilter({ schema, proposalFilterType }) {
  const history = useHistory()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const [isLoading, setIsLoading] = useState(false)
  const [isError, setIsError] = useState(false)
  const [isShowConfimModal, setIsShowConfimModal] = useState(false)
  const {
    register,
    handleSubmit,
    errors,
    control,
    setValue,
    setError,
    clearErrors,
    watch,
    getValues,
  } = useForm()

  const watchProposalFilter = watch('proposalFilter', '1')
  const [formSchema, setFormSchema] = useState(schema)
  const [isCheckCOI, setIsCheckCOI] = useState(false)
  const [isCOIPass, setIsCOIPass] = useState(false)
  const [checkCOI, setCheckCOI] = useState(false)
  const [isShowMsg, setIsShowMsg] = useState(false)
  const [checkInterest, setCheckInterest] = useState(false)

  useEffect(() => {
    if (formSchema.ProjectFilterSummary?.proposalFilter?.value) {
      setValue('proposalFilter', formSchema.ProjectFilterSummary.proposalFilter.value)
    } else {
      setValue(
        'proposalFilter',
        formSchema.ProjectFilterSummary?.proposalFilter?.options[0]?.value || '1'
      )
    }
  }, [])

  useEffect(() => {
    if (formSchema.ProjectDepartment?.institution?.value) {
      setValue('institution', formSchema.ProjectFilterSummary.proposalFilter.value)
    } else {
      const departmentCode = localStorage.getItem('department_code')
      departmentCode && setValue('institution', departmentCode)
    }
  }, [])

  const handleSaveProposalFilter = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsError()
    try {
      let _schema = {}
      if (proposalFilterType === ProposalFilterType.PROPOSAL_FILTER_6) {
        _schema = await saveProposalFilter6(request)
      } else if (proposalFilterType === ProposalFilterType.PROPOSAL_FILTER_OTHER) {
        _schema = await saveProposalFilterOther(request)
      }
      doneLoading()
      const _projectVersionId =
        _schema.projectVersionId || _schema.model?.projectVersionId || projectId

      sessionStorage.setItem('projectId', _projectVersionId)
      sessionStorage.setItem('param', '')

      return history.push(`${pathname.proposal.overview.overviewCoworker}`)
    } catch (e) {
      // console.log('e', e?.response?.data?.errorMessage)
      setIsError('เกิดข้อผิดพลาดในการบันทึก กรุณาลองใหม่อีกครั้งหรือติดต่อผู้ดูแลระบบ')
    }
    setIsLoading(false)
    doneLoading()
  }

  const onSubmit = () => {
    setIsError()
    setIsShowConfimModal(true)
  }

  const handleOnConfirmModal = (data) => {
    console.log('data => ', data)
    // console.log('checkCOI => ', checkCOI)
    // console.log('checkInterest => ', checkInterest)

    let req = {
      projectVersionId: projectId,
      filterSummary: data.filterSummary,
      proposalFilter: data.proposalFilter,
      departmentCode: data.institution,
      filterType: data.filterType,
      employeeCode: data.coordinator,
      isCOI: checkCOI,
    }

    if (watchProposalFilter == '5') {
      let notSelected = true

      // set projectFeedbackId = null (ถ้ามีค่า จะถูกหลังบ้านลบทิ้ง และภาคีจะไม่เห็น)
      for (const item of data.requestBody) {
        if (item.subItems) {
          for (const subItem of item.subItems) {
            subItem.projectFeedbackId = null

            //check if not select throw error
            if (subItem.selected && subItem.value) {
              notSelected = false
            }

            if (subItem.subItems) {
              for (const subSubItem of subItem.subItems) {
                subSubItem.projectFeedbackId = null

                //check if not select throw error
                if (subSubItem.selected && subSubItem.value) {
                  notSelected = false
                }
              }
            }
          }
        }
      }

      //check if not select throw error
      if (notSelected) {
        setIsError('กรุณาเลือกหัวข้อที่ต้องการส่งกลับแก้ไข')
      }

      req = { ...req, projectFeedback: data.requestBody }
    }
    setIsShowConfimModal(false)
    handleSaveProposalFilter(req)
  }

  const handleSubmitCoi = async (step) => {
    startLoading()
    setIsLoading(true)
    try {
      const request = {
        isCOI: 1,
        stepCode: step,
      }

      const _schema = await saveProposalFilterCoi(request, projectId)

      if (_schema.isSuccess) {
        notification.open('success', {
          title: 'บันทึกสำเร็จ',
          duration: 5000,
        })

        history.push({
          // pathname: pathname.proposal.review.proposalReviseRequest,
          pathname: pathname.proposal.overview.overviewCoworker,
        })
      }
    } catch (e) {
      console.error('error => ', e)
      notification.open('error', {
        title: 'บันทึกไม่สำเร็จ',
        duration: 5000,
      })
    }
    setIsLoading(false)
    doneLoading()
  }

  return (
    <>
      {formSchema && (
        <Form fluid>
          <Panel
            shaded
            header={formSchema.ProjectFilterSummary?.headerSummary}
            bordered
            collapsible
            defaultExpanded
          >
            <>
              {proposalFilterType === ProposalFilterType.PROPOSAL_FILTER_6 && (
                <div style={{ marginTop: 30, marginBottom: 30 }}>
                  <COIValidateWidget
                    disabled={
                      formSchema.ProjectFilterSummary?.proposalFilter?.disabled || isLoading
                    }
                    isCOIPass={isCOIPass}
                    setIsCOIPass={setIsCOIPass}
                    checkCOI={checkCOI}
                    setCheckCOI={setCheckCOI}
                    setIsCheckCOI={setIsCheckCOI}
                    setCheckInterest={setCheckInterest}
                    checkInterest={checkInterest}
                    fixType={'2'}
                  />
                </div>
              )}

              <ProposalFilterSummaryForm
                schema={formSchema.ProjectFilterSummary}
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
              />

              {(watchProposalFilter == '3' || watchProposalFilter == '4') && (
                <>
                  <hr />
                  {isError && (
                    <Message
                      showIcon
                      type="error"
                      description={isError}
                      style={{ marginBottom: 10 }}
                    />
                  )}
                  <SaveButton
                    onClick={handleSubmit(onSubmit)}
                    disabled={
                      formSchema.ProjectFilterSummary?.proposalFilter?.disabled || isLoading
                    }
                    children="บันทึกผลการคัดกรอง"
                  />
                </>
              )}
            </>
          </Panel>
          <br />

          {(watchProposalFilter == '1' || watchProposalFilter == '2') && (
            <>
              <Panel
                shaded
                header={formSchema.ProjectDepartment?.headerQualify}
                bordered
                collapsible
                defaultExpanded
              >
                <SingleDropdownForm
                  schema={formSchema.ProjectDepartment?.institution}
                  error={errors.institution}
                  register={register}
                  Controller={Controller}
                  control={control}
                  setValue={setValue}
                  clearErrors={clearErrors}
                  onChangeValue={(value) => {
                    console.log('v => ', value)
                  }}
                />

                {formSchema.ProjectDepartment?.coordinator && (
                  <SingleDropdownForm
                    schema={formSchema.ProjectDepartment?.coordinator}
                    error={errors.coordinator}
                    searchable={true}
                    register={register}
                    Controller={Controller}
                    control={control}
                    setValue={setValue}
                    clearErrors={clearErrors}
                    onChangeValue={(value) => {
                      console.log('onChangeValue => ', value)
                      //เมื่อมีการเปลี่ยนนักวิชาการใหม่ให้ตรวจสอบ coi ก่อนเสมอ
                      setIsCOIPass(false)
                      setIsShowMsg(!!value)
                    }}
                  />
                )}

                {!formSchema.ProjectFilterType && (
                  <>
                    <hr />
                    {isError && (
                      <Message
                        showIcon
                        type="error"
                        description={isError}
                        style={{ marginBottom: 10 }}
                      />
                    )}

                    <SaveButton
                      onClick={handleSubmit(onSubmit)}
                      disabled={
                        formSchema.ProjectFilterSummary?.proposalFilter?.disabled ||
                        isLoading ||
                        !isCOIPass ||
                        !checkCOI
                      }
                      children="บันทึกผลการคัดกรอง"
                    />
                    {checkInterest && (
                      <>
                        <SaveButton
                          onClick={() => {
                            handleSubmitCoi(2)
                          }}
                          disabled={
                            formSchema.ProjectFilterSummary?.proposalFilter?.disabled || isLoading
                          }
                          children="บันทึก"
                        />
                      </>
                    )}
                  </>
                )}
              </Panel>
              <br />
              {formSchema.ProjectFilterType && (
                <Panel
                  shaded
                  header={formSchema.ProjectFilterType?.header}
                  bordered
                  collapsible
                  defaultExpanded
                >
                  <SingleRadioForm
                    schema={formSchema.ProjectFilterType?.filterType}
                    error={errors.filterType}
                    register={register}
                    Controller={Controller}
                    control={control}
                    setValue={setValue}
                    clearErrors={clearErrors}
                  />

                  <COIValidateWidget
                    disabled={
                      formSchema.ProjectFilterSummary?.proposalFilter?.disabled || isLoading
                    }
                    isCOIPass={isCOIPass}
                    setIsCOIPass={setIsCOIPass}
                    checkCOI={checkCOI}
                    setCheckCOI={setCheckCOI}
                    setIsCheckCOI={setIsCheckCOI}
                    setCheckInterest={setCheckInterest}
                    checkInterest={checkInterest}
                    fixType={'3'}
                    getValues={getValues}
                  />
                  <hr />
                  {isError && (
                    <Message
                      showIcon
                      type="error"
                      description={isError}
                      style={{ marginBottom: 10 }}
                    />
                  )}

                  {isShowMsg && !isCOIPass && !checkInterest && (
                    <Message
                      showIcon
                      type="warning"
                      description={
                        'กรณีมีการเปลี่ยนแปลง นักวิชาการ/ผู้ประสาน กรุณาตรวจสอบ COI ใหม่'
                      }
                      style={{ marginBottom: 10 }}
                    />
                  )}

                  <SaveButton
                    onClick={handleSubmit(onSubmit)}
                    disabled={
                      formSchema.ProjectFilterSummary?.proposalFilter?.disabled ||
                      isLoading ||
                      !isCOIPass ||
                      !checkCOI
                    }
                    children="บันทึกผลการคัดกรอง"
                  />

                  {checkInterest && (
                    <>
                      <SaveButton
                        onClick={() => {
                          handleSubmitCoi(3)
                        }}
                        disabled={
                          formSchema.ProjectFilterSummary?.proposalFilter?.disabled || isLoading
                        }
                        children="บันทึก"
                      />
                    </>
                  )}
                </Panel>
              )}

              <br />
            </>
          )}

          {watchProposalFilter == '5' && (
            <>
              <Panel shaded header="" bordered collapsible defaultExpanded>
                <ProposalReviseForm
                  schema={formSchema.ProjectFeedback?.revises}
                  register={register}
                  Controller={Controller}
                  control={control}
                  errors={errors}
                  setValue={setValue}
                  clearErrors={clearErrors}
                />

                {/* {!formSchema.ProjectFilterType && ( */}
                <>
                  <hr />
                  {isError && (
                    <Message
                      showIcon
                      type="error"
                      description={isError}
                      style={{ marginBottom: 10 }}
                    />
                  )}
                  <SaveButton
                    onClick={handleSubmit(onSubmit)}
                    children="ส่งแก้ไขข้อเสนอ"
                    disabled={
                      formSchema.ProjectFilterSummary?.proposalFilter?.disabled || isLoading
                    }
                  />
                </>
                {/* )} */}
              </Panel>
              {/* <br />
              {formSchema.ProjectFilterType && (
                <Panel
                  shaded
                  header={formSchema.ProjectFilterType?.header}
                  bordered
                  collapsible
                  defaultExpanded
                >
                  <SingleRadioForm
                    schema={formSchema.ProjectFilterType?.filterType}
                    error={errors.filterType}
                    register={register}
                    Controller={Controller}
                    control={control}
                    setValue={setValue}
                    clearErrors={clearErrors}
                  />
                  <hr />
                  {isError && (
                    <Message
                      showIcon
                      type="error"
                      description={isError}
                      style={{ marginBottom: 10 }}
                    />
                  )}
                  <SaveButton
                    onClick={handleSubmit(onSubmit)}
                    disabled={
                      formSchema.ProjectFilterSummary?.proposalFilter?.disabled || isLoading
                    }
                  />
                </Panel>
              )} */}
            </>
          )}

          {/* {watchProposalFilter == '3' && (
          <>
            <Panel
              shaded
              header={formSchema.ProjectDepartment?.headerNotQualify}
              bordered
              collapsible
              defaultExpanded
            >
              <SingleDropdownForm
                schema={formSchema.ProjectDepartment?.institution}
                error={errors.institution}
                register={register}
                Controller={Controller}
                control={control}
                setValue={setValue}
                clearErrors={clearErrors}
              />
              <hr />
              {isError && (
                <Row style={{ marginBottom: 10 }}>
                  <Message showIcon type="error" description={'เกิดข้อผิดพลาดในการบันทึก กรุณาลองใหม่อีกครั้งหรือติดต่อผู้ดูแลระบบ'} />
                </Row>
              )}
              <SaveButton
                onClick={handleSubmit(onSubmit)}
                disabled={formSchema.ProjectFilterSummary?.proposalFilter?.disabled || isLoading}
              />
            </Panel>
          </>
        )} */}
          <ConfirmWidget
            title={`ยืนยันการบันทึก`}
            show={isShowConfimModal}
            detail={`กรุณายืนยันการบันทึก`}
            onCancle={() => setIsShowConfimModal(false)}
            onConfirm={handleSubmit(handleOnConfirmModal)}
          />
        </Form>
      )}
    </>
  )
}
